"use strict";

// configuration
var ubian = ubian || {};
ubian.config = {};
ubian.config.dateFormat = "DD.MM.YYYY";
ubian.config.selectpickerDefaultOptions = { size: 5, noneSelectedText: "" };

/**
 * show password when user clicks eye icon
 * @returns {undefined}
 */
ubian.showPassword = function(element) {
  var where = typeof element === "undefined" ? "body" : element;
  $inputs = $(where)
    .find("input[type=password]")
    .each(function() {
      if ($(this).data("password-handler")) {
        return;
      }
      $(this).data("password-handler", true);
      var $toggler = $(
        '<span class="show-password"></span><div class="clearfix"></div>'
      );
      $(this).after($toggler);
      var input = this;
      $(this).focus(function() {
        $toggler.addClass("focus");
      });
      $(this).blur(function() {
        $toggler.removeClass("focus");
      });
      $toggler.on("touchstart mousedown", function(e) {
        e.preventDefault();
        $(input).attr("type", "text");
        $(input).addClass("password-shown");
        $(input).focus();
      });
      $toggler.on("touchend mouseup", function() {
        $(input).attr("type", "password");
        $(input).removeClass("password-shown");
        $(input).focus();
      });
    });
};

$(function() {
  // Popover
  $('[data-toggle="popover"]').popover();
  // popover close on click outside
  $(document).on("click", function(e) {
    $('[data-toggle="popover"],[data-original-title]').each(function() {
      //the 'is' for buttons that trigger popups
      //the 'has' for icons within a button that triggers a popup
      if (
        !$(this).is(e.target) &&
        $(this).has(e.target).length === 0 &&
        $(".popover").has(e.target).length === 0
      ) {
        (
          (
            $(this)
              .popover("hide")
              .data("bs.popover") || {}
          ).inState || {}
        ).click = false; // fix for BS 3.3.6
      }
    });
  });

  // Selectpicker
  $(".selectpicker").selectpicker(ubian.config.selectpickerDefaultOptions);
  // prevent submitting of empty forms
  $(".js-prevent-empty").submit(function() {
    var valid = true;
    $(this)
      .find("input")
      .each(function() {
        if (!$(this).val()) {
          valid = false;
        }
      });
    return valid;
  });
  // Mobile menu
  var $mt = $(".menutoggler");
  $mt.on("click", function() {
    $mt.toggleClass("on");
    if ($mt.is(".on")) {
      $("body").addClass("openmobile");
    } else {
      $("body").removeClass("openmobile");
    }
  });

    $('.collapsible-orders').on('click', '.collapse-toggler', function (e) {
        var $t = $(this);
        var $collapsible_rows = $t.parent().find('.collapsible');

        $t.toggleClass('toggled');
        $collapsible_rows.toggleClass('collapsed');
    });

    $('.collapsible-table').on('click', '.collapse-toggler', function (e) {
    var $t = $(this);
    var $tb = $t.parent().parent();

    $tb.toggleClass("collapsed");
  });

  ubian.showPassword();
  ubian.cookieConsent.init();
  ubian.globalNotice.init();
  ubian.appDownload.init();
});

/**
 * handler for all unexpected javascript errors
 */
$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
    if (jqxhr.responseText) {
        try {
            var response = jQuery.parseJSON(jqxhr.responseText);
            console.log('response',response);
            if (response.error_code === 'DA-DANC-191' || response.error_code === 'DA-DANC-192' || response.error_code === 'DA-DANC-193'){
                return ubian.profile.setErrorMessage(response);
            }
            if (typeof response.error_message !== 'undefined') {
                ubian.utils.alert(response.error_message);
            }
            
        } catch (e) {

        }

    }
});

// multiple modals

$(document).on("shown.bs.modal", ".modal", function() {
  var zIndex = 1040 + 10 * $(".modal:visible").length;
  $(this).css("z-index", zIndex);
  setTimeout(function() {
    $(".modal-backdrop")
      .not(".modal-stack")
      .css("z-index", zIndex - 1)
      .addClass("modal-stack");
  }, 0);
});

$(document).on("hidden.bs.modal", ".modal", function() {
  $(".modal:visible").length && $(document.body).addClass("modal-open");
});

// sticky header
$(function() {
  var stickyHeaderTimeout = null;

  var stickyHeader = function() {
    if (
      $("header").length &&
      !$("header").data("sticky") &&
      $(window).outerWidth() >= 768
    ) {
      $("header").stick_in_parent();
      $("header").data("sticky", 1);
      return;
    }
    if ($("header").data("sticky") && $(window).outerWidth() < 768) {
      $("header").data("sticky", 0);
      $("header").trigger("sticky_kit:detach");
    }
  };

  $(window).resize(function() {
    if (stickyHeaderTimeout) {
      clearTimeout(stickyHeaderTimeout);
    }
    stickyHeaderTimeout = setTimeout(stickyHeader, 150);
  });
});

/**
 * custom validation error messages for input fields
 * @returns {undefined}
 */
$(function() {
  $("[required]").bind("invalid", function() {
    var errorMessage = ubian.translate("JS.Required.Error.Empty");
    if (this.validity.badInput && this.type == "number") {
      errorMessage = ubian.translate("JS.Required.Error.Number");
    }
    this.setCustomValidity(errorMessage);
  });
  $("[required]").bind("input", function() {
    var errorMessage = "";
    if (this.validity.valueMissing) {
      errorMessage = ubian.translate("JS.Required.Error.Empty");
      if (this.validity.badInput && this.type == "number") {
        errorMessage = ubian.translate("JS.Required.Error.Number");
      }
    }
    this.setCustomValidity(errorMessage);
  });
});

$(function() {
  $(".dropdown-card-list .dropdown-toggle").click(function() {
    // returns negated state of menu status
    var state = $(this).attr("aria-expanded");
    if (state == "false") {
      $("body").addClass("not-scrollable");
      setTimeout(function() {
        $("body").one("click", function() {
          $("body").removeClass("not-scrollable");
        });
      }, 100);
    } else {
      $("body").removeClass("not-scrollable");
    }
  });
});

$(function () {
    var key = 'ubian_hiddenAnnouncements';
    var hiddenAnnouncements = Cookies.getJSON(key) || [];
    var $announcement = $('.js-system-announcement');
    var id = parseInt($announcement.data('id'));
    if (hiddenAnnouncements.indexOf(id) > -1) {
        return;
    }
    $announcement.show();
    $announcement.find('button').click(function () {
        hiddenAnnouncements.push(id);
        $announcement.remove();
        try {
            Cookies.set(key, hiddenAnnouncements, { path: '/' });
        } catch (e) {

        }
    });
});


String.prototype.ucFirst = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
